export default __webpack_public_path__ + "static/飞书20210924-194610-01f614d100f7241599b5b4c2157d2894.png";